import { render } from "./LoadingCanvas.vue?vue&type=template&id=10f2f01e&scoped=true"
const script = {}

import "./LoadingCanvas.vue?vue&type=style&index=0&id=10f2f01e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f2f01e"]])

export default __exports__